import { AITweakInteractionStatus, AITweakSource } from "../../../foundation/api/model/AITweak/AITweak";

const loadingStateResponse = {
    _id: "LOADING_LINE_ID",
    message: "Thinking…",
    source: AITweakSource.AGENT,
    status: AITweakInteractionStatus.PENDING
};

const cancelledStateResponse = {
    _id: "CANCELLED_LINE_ID",
    message: "Cancelled",
    source: AITweakSource.AGENT,
    status: AITweakInteractionStatus.IDLE
};

export {
    loadingStateResponse,
    cancelledStateResponse
};
